// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-home-J":"J_power-ocean-home-J__P51Pg"};